import { render, staticRenderFns } from "./TestimonialThree.vue?vue&type=template&id=4a5b38a5&"
import script from "./TestimonialThree.vue?vue&type=script&lang=js&"
export * from "./TestimonialThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports